"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillToJSON = exports.BillFromJSONTyped = exports.BillFromJSON = exports.instanceOfBill = void 0;
var runtime_1 = require("../runtime");
var BillStatus_1 = require("./BillStatus");
var PaymentDetails_1 = require("./PaymentDetails");
/**
 * Check if a given object implements the Bill interface.
 */
function instanceOfBill(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBill = instanceOfBill;
function BillFromJSON(json) {
    return BillFromJSONTyped(json, false);
}
exports.BillFromJSON = BillFromJSON;
function BillFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, BillStatus_1.BillStatusFromJSON)(json['status']),
        'paymentDetails': !(0, runtime_1.exists)(json, 'payment_details') ? undefined : (0, PaymentDetails_1.PaymentDetailsFromJSON)(json['payment_details']),
        'issuedAt': !(0, runtime_1.exists)(json, 'issued_at') ? undefined : (new Date(json['issued_at'])),
        'totalInMicros': !(0, runtime_1.exists)(json, 'total_in_micros') ? undefined : json['total_in_micros'],
        'totalTaxInMicros': !(0, runtime_1.exists)(json, 'total_tax_in_micros') ? undefined : json['total_tax_in_micros'],
        'taxDescription': !(0, runtime_1.exists)(json, 'tax_description') ? undefined : json['tax_description'],
    };
}
exports.BillFromJSONTyped = BillFromJSONTyped;
function BillToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ad_account_id': value.adAccountId,
        'status': (0, BillStatus_1.BillStatusToJSON)(value.status),
        'payment_details': (0, PaymentDetails_1.PaymentDetailsToJSON)(value.paymentDetails),
        'issued_at': value.issuedAt === undefined ? undefined : (value.issuedAt.toISOString()),
        'total_in_micros': value.totalInMicros,
        'total_tax_in_micros': value.totalTaxInMicros,
        'tax_description': value.taxDescription,
    };
}
exports.BillToJSON = BillToJSON;
